import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.event_booking';
export const Component = loadable(
  () => import('./containers/EventBookingContainer')
);
export { default as propsFormatter } from './propsFormatter';
